import { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// GET Request Schemas //
// Endpoint: /api/create-quote/accessorials
export const accessorialSchema = idNameSchema.extend({
	accessorialUsageTypeId: z.number(),
	accessorialUsageType: idNameSchema,
	isActive: z.boolean(),
	stopTypeId: z.number().nullable(),
	stopType: idNameSchema.nullable(),
	ediCode: z.string().nullable(),
	p44APICode: z.string().nullable(),
	code: z.string().nullable(),
	isSubjectToFuelSurcharge: z.boolean(),
	isHazmat: z.boolean(),
});

// Type inference
export type Accessorial = z.infer<typeof accessorialSchema>;
